module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousDailyVehicleTrackView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("TPT Dashboard")])], 1), _vm._v(" "), _c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('date-range-picker', {
    staticClass: "mb-1",
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  }), _vm._v(" "), _c('span', [_c('b', [_vm._v("Total Available : ")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.TotaAvilableVehicle))])]), _vm._v("    \n            "), _c('span', [_c('b', [_vm._v("Total Booked : ")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.TotaBookedVehicle))])])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "9"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('b-button', {
    staticClass: "ml-auto",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('TPTDashbord_SCREEN', 'Export as Excel')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnName) + "\n                  "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "ml-auto",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.DailyVehicleTrack
    }
  }, [_vm._v("Daily Vehicle Tracking Status")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.veiwVehicleMaster,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "sr_no",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "regdNo",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.regdNo))])]
      }
    }, {
      key: "isTruckMasterActive",
      fn: function(row2) {
        return [(
          row2.item.isTruckMasterActive == '1' &&
          row2.item.vehicleActiveInactiveId == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Available")])], 1) : _vm._e(), _vm._v(" "), (
          row2.item.isTruckMasterActive == '0' &&
          row2.item.vehicleActiveInactiveId == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Booked")])], 1) : _vm._e(), _vm._v(" "), (row2.item.vehicleActiveInactiveId == '2') ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("INACTIVE")])], 1) : _vm._e()]
      }
    }, {
      key: "TripCount",
      fn: function(row4) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.showToTTrip(row4.item)
            }
          }
        }, [_vm._v(_vm._s(row4.item.TripCount) + "\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-modal', {
    ref: "Trip-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Trip Details"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.TripDetails.length > 0) ? _c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.TripDetails,
      "fields": _vm.TripCount,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "sr_no",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "Vehicle_NO",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.Vehicle_NO))])]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.mainSalesSeries))]), _vm._v(" "), (
          row2.item.isTruckMasterActive == '1' &&
          row2.item.vehicleActiveInactiveId == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Available")])], 1) : _vm._e(), _vm._v(" "), (
          row2.item.isTruckMasterActive == '0' &&
          row2.item.vehicleActiveInactiveId == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Booked")])], 1) : _vm._e(), _vm._v(" "), (row2.item.vehicleActiveInactiveId == '2') ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("INACTIVE")])], 1) : _vm._e()]
      }
    }, {
      key: "clientName",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.clientName))])]
      }
    }, {
      key: "default",
      fn: function(row5) {
        return [(
          row5.item.status == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Available")])], 1) : _vm._e(), _vm._v(" "), (
          row5.item.status == '2'
        ) ? _c('h6', [_vm._v("VehicleStatus\n                    "), _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Booked")])], 1) : _vm._e()]
      }
    }, {
      key: "status",
      fn: function(row6) {
        return [(
          row6.item.status == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Available")])], 1) : _vm._e(), _vm._v(" "), (
          row6.item.status == '2'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Booked")])], 1) : _vm._e()]
      }
    }, {
      key: "skipGRN",
      fn: function(row7) {
        return [(row7.item.skipGRN == '0') ? _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-success"
          },
          on: {
            "click": function($event) {
              _vm.Print(row7.item.pdfGRN)
            }
          }
        }, [_vm._v("GRN PDF")]) : _vm._e()]
      }
    }, {
      key: "tptType",
      fn: function(row8) {
        return [_vm._v(_vm._s((row8.item.tptType == 1) ? 'Pridel' : 'Outsourced'))]
      }
    }, {
      key: "distance",
      fn: function(row9) {
        return [_vm._v(_vm._s(row9.item.distance))]
      }
    }, {
      key: "tollInCash",
      fn: function(row10) {
        return [_vm._v(_vm._s(row10.item.tollInCash))]
      }
    }, {
      key: "otherCashExpenses",
      fn: function(row11) {
        return [_vm._v(_vm._s(row11.item.otherCashExpenses))]
      }
    }, {
      key: "diesel",
      fn: function(row12) {
        return [_vm._v(_vm._s(row12.item.diesel))]
      }
    }, {
      key: "dieselPrice",
      fn: function(row13) {
        return [_vm._v(_vm._s(row13.item.dieselPrice))]
      }
    }, {
      key: "totalCost",
      fn: function(row14) {
        return [_vm._v(_vm._s(row14.item.totalCost))]
      }
    }, {
      key: "cashDeiselPaid",
      fn: function(row15) {
        return [_vm._v(_vm._s(row15.item.cashDeiselPaid))]
      }
    }])
  })], 1) : _vm._e()])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2 justify-content-center"
  }, [_c('div', [_c('b-button', {
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideToTTrip
    }
  }, [_vm._v("Close")])], 1)])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed9cb29e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/tptDashboard.vue
// module id = 2907
// module chunks = 0